<template>
  <div class="lock-ticket" id="lock-ticket">
<!--      <a href="https://if.geekpark.net/ticketcenter/" target="_blank">-->
      <a href="https://events.geekpark.net/orders/index/cn/if20" target="_blank">
<!--        <img src="https://summit-img.geekpark.net/ifx/images/%E7%A5%A8-mobile-v2.jpg" style=" width: 100vw;">-->
        <img src="https://summit-img.geekpark.net/mobile/2020%E9%A2%84%E5%94%AE%E7%A5%A8v2-m.jpg" style=" width: 100vw;">
      </a>
    </div>
</template>

<script>
export default {
  name: 'LockTicket'
}
</script>

<style scoped lang="less">
  .lock-ticket {
    margin-top: 10vw;
    width: 100%;
    height: 80vw;
  }
  a{
    display: block;
  }
  .content {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #d8d8d8;
  }
</style>
